import { getTransform } from "./qaConfig"

const getKendoConfig = {
  ...getTransform("dk_kendo_edit_icon"),
}

export { getKendoConfig }
